import React, { useMemo, useState, useEffect } from 'react';
import { Box, Grid, Typography, Tab,useMediaQuery } from '@mui/material';
import { TabContext, TabPanel, TabList } from '@mui/lab';
import step1 from '../../../assets/images/step1.png';
import verification from '../../../assets/images/verification.png';
import report from '../../../assets/images/report.png';
import EnrollStep1 from '../../../Components/FundingShot/EnrollStep1';
import Verification from '../../../Components/FundingShot/Verification';
import ScoreReport from '../../../Components/FundingShot/ScoreReport';
import Header from './Header';
import Footer from './Footer';
import { isMoment } from 'moment';
function FundingShotIndex(props) {
      const isMobile = useMediaQuery('(max-width:600px)');
    const [tabValue, setTabValue] = useState("1");

    const handleChange = (event, newValue) => {
      setTabValue(newValue);
    };
  
    const StepCircle = ({ src, label, active }) => (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          sx={{
            backgroundColor: active  ? '#0F31AC' : '#918b96',
            width:isMobile?45: 60,
            height:isMobile?45:  60,
            borderRadius: isMobile?'30%': '40%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
            cursor: 'pointer'
          }}
        >
          <img src={src} alt={label} style={{ width: isMobile?"15px":'20px' }} />
        </Box>
        <Typography mt={1} sx={{fontSize:isMobile? "12px": "16px"}}>{label}</Typography>
      </Box>
    );
  
    const Arrow = () => (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          sx={{
            width:isMobile ? 50: 100,
            height: 1,
            borderTop: '2px dotted black',
            position: 'relative',
            mt:isMobile?"0px": "-16px",
          }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              backgroundColor: 'black',
              transform: 'rotate(45deg)',
              position: 'absolute',
              top: '-6px',
              left: '100%',
              transformOrigin: 'center',
            }}
          />
        </Box>
      </Box>
    );
  
    return (
      <>
      <Header/>
      <TabContext value={tabValue}>
        <Grid container alignItems="center" justifyContent="center" spacing={3} mt={1}>
          {/* Step 1 */}
          <Grid item>
            <StepCircle src={step1} label="Get Started" active={tabValue === "1"} />
          </Grid>
  
          <Grid item sx={{paddingLeft:isMobile?"9px !important":"24px!important"}}>
            <Arrow />
          </Grid>
  
          {/* Step 2 */}
          <Grid item>
            <StepCircle src={verification} label="Verify Identity" active={tabValue === "2"} />
          </Grid>
  
          <Grid item sx={{paddingLeft:isMobile?"9px!important":"24px!important"}}>
            <Arrow />
          </Grid>
  
          {/* Step 3 */}
          <Grid item>
            <StepCircle src={report} label="Get Report" active={tabValue === "3"} />
          </Grid>
        </Grid>
  
        {/* Content for Each Step */}
        <Box>
          <TabPanel value="1">
            {/* Your Step 1 Content Here */}
            <EnrollStep1 />
          </TabPanel>
          <TabPanel value="2">
            {/* Your Step 2 Content Here */}
            <Verification />
          </TabPanel>
          <TabPanel value="3">
            {/* Your Step 3 Content Here */}
            <ScoreReport />
          </TabPanel>
        </Box>
      </TabContext>
      <Footer/>
      </>
    );
  };

        export default FundingShotIndex;